import EventHandler from '@pixelunion/events';
import Disclosure from '@pixelunion/shopify-cross-border';
import { transition } from '@pixelunion/animations';
import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';

import ScrollLock from '../helpers/ScrollLock';
import NavMobileSubmenu from './NavMobileSubmenu';

export default class NavMobileMenu {
  constructor({ controls, mobileNav }) {
    this.controls = controls;
    this.mobileNav = mobileNav;
    this.submenu = null;

    this.mobileTrigger = this.controls.querySelector('[data-mobile-nav-trigger]');
    this.closeButton = this.mobileNav.querySelector('[data-mobile-nav-close]');
    this.mainFlyout = this.mobileNav.querySelector('[data-mobile-main-flyout]');
    this.overlay = this.mobileNav.querySelector('[data-mobile-overlay]');
    this.submenuTriggers = this.mobileNav.querySelectorAll('[data-mobile-submenu-button="tier-1"]');

    this.events = new EventHandler();

    this.flyoutAnimation = transition({ el: this.mainFlyout, state: 'closed' });
    this.overlayAnimation = transition({ el: this.overlay, state: 'closed' });

    this.closeEsc = e => {
      if (e.key === 'Escape') {
        this.close();
      }
    };

    this.events.register(this.mobileTrigger, 'click', event => this.open(event));
    this.events.register(this.closeButton, 'click', () => this.close());
    this.events.register(this.overlay, 'click', () => this.close());

    this.submenuTriggers.forEach(submenuTrigger => {
      this.events.register(submenuTrigger, 'click', e => this.openSubmenu(e));
    });

    // Currency and Language selectors
    this.currencyDisclosureEl = this.mobileNav.querySelector('[data-disclosure-currency]');
    this.localeDisclosureEl = this.mobileNav.querySelector('[data-disclosure-locale]');
    this.disclosures = [];

    if (this.currencyDisclosureEl) {
      this.disclosures.push(new Disclosure(this.currencyDisclosureEl));
    }

    if (this.localeDisclosureEl) {
      this.disclosures.push(new Disclosure(this.localeDisclosureEl));
    }
  }

  open(e) {
    e.preventDefault();
    ScrollLock.lock(this.mobileNav);

    this.mobileNav.dataset.open = true;
    this.flyoutAnimation.animateTo('open');
    this.overlayAnimation.animateTo('open');

    this.closeEvent = this.events.register(window, 'keydown', e => this.closeEsc(e));

    this.mobileNav.focus();
    trapFocus(this.mobileNav);
  }

  close() {
    ScrollLock.unlock();

    removeTrapFocus(this.mobileNav);
    this.mobileTrigger.focus();

    this.mobileNav.dataset.childOpen = false;

    this.events.unregister(this.closeEvent);

    this.flyoutAnimation.animateTo('closed');
    this.overlayAnimation.animateTo('closed')
      .then(() => {
        this.mobileNav.dataset.open = false;

        if (this.submenu) {
          this.submenu.unload();
        }
      });
  }

  openSubmenu(e) {
    const submenuTrigger = e.target;
    const submenu = submenuTrigger.nextElementSibling;

    this.mobileNav.dataset.childOpen = true;

    this.submenu = new NavMobileSubmenu({
      submenu,
      trigger: submenuTrigger,
      parentMenu: this.mobileNav,
      tier: 2,
      mobileMenu: this,
    });
  }

  unload() {
    if (this.submenu) {
      this.submenu.unload();
    }

    this.flyoutAnimation.animateTo('closed', { force: true });
    this.overlayAnimation.animateTo('closed', { force: true });

    this.flyoutAnimation.unload();
    this.overlayAnimation.unload();
    this.disclosures.forEach(disclosure => disclosure.unload());
    this.events.unregisterAll();
  }
}
